import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';

import AdatosLogo from '../asset/svg/Adatos';

const styles = (theme) => {
    return {
        layout: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            margin: 'auto',
            textAlign: 'center',
            display: 'inline-block',
        },
        region: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            marginLeft: 40,
            marginRight: 40,
            marginTop: 45,
            marginBottom: 45,
            zIndex: 10,
        },
        logoContainer: {
            textAlign: 'left',
        },
        logo: {
            height: '100%',
            width: 160,
            color: theme.palette.primary.main,
        },
        heading: {
            marginTop: 20,
        },
        subHeading: {
            marginBottom: 20,
        },
        loadingProgress: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
        },
        disableOverlay: {
            position: 'absolute',
            top: 5,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 1500,
        }
    };
}

class FormPaper extends Component {
    render = () => {
        const {classes} = this.props;

        return (
            <Paper
                className={classNames(classes.layout, this.props.className)}
                style={this.props.style}
            >
                {this._renderProgress()}
                {this._renderDisableOverlay()}
                <div className={classes.region}>
                    <div className={classes.logoContainer}>
                        <AdatosLogo className={classes.logo}/>
                    </div>
                    <Typography
                        className={classes.heading}
                        gutterBottom={true}
                        variant='h5'
                        align='left'
                    >
                        {this.props.heading}
                    </Typography>
                    <Typography
                        className={classes.subHeading}
                        gutterBottom={true}
                        variant='subtitle1'
                        align='left'
                    >
                        {this.props.subHeading}
                    </Typography>
                    {this.props.children}
                </div>
            </Paper>
        );
    }

    _renderProgress = () => {
        const {classes} = this.props;

        if (!this.props.loading) {
            return null;
        }

        return (
            <LinearProgress
                className={classes.loadingProgress}
                color={'secondary'}
            />
        );
    }

    _renderDisableOverlay = () => {
        const {classes} = this.props;

        if (!this.props.loading) {
            return null;
        }

        return (
            <div
                className={classes.disableOverlay}
                color={'secondary'}
            />
        );
    }
}

FormPaper.propTypes = {
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    loading: PropTypes.bool,
}

export default withStyles(styles)(FormPaper)
